import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IsrHomeIcon from '@material-ui/icons/Home';
import PremiumTrendIcon from '@material-ui/icons/TrendingUp';
import InsurerDataSheetIcon from '@material-ui/icons/AccountBalance';
import CountyDataSheetIcon from '@material-ui/icons/Language';
import CoverageCodeSheetIcon from '@material-ui/icons/HomeWork';
import TransactionTypeComparisonIcon from '@material-ui/icons/Compare';
import { Menu as MenuIcon } from '@material-ui/icons';
import { APPLICATION_NAME, APPLICATION_OWNER_NAME } from 'constants/application';
import { ROUTE_CONSTANTS } from 'constants/route';
import MSLALogo from '../MSLALogo';

const useStyles = makeStyles((theme) => ({
  masthead: {
    display: 'flex',
    height: '100px',
    color: '#fff',
    background: '#fff',
  },
  logoContainer: {
    flexBasis: '100px',
    padding: '15px',
    background: '#0f487e',
  },
  mslaLogo: { height: '70px' },
  titleContainer: {
    flex: 1,
    padding: '1.5rem',
    color: '#0f487e',
    fontFamily: 'Roboto Slab',
    [theme.breakpoints.down('xs')]: {
      padding: '1.75rem 1.5rem',
    },
  },
  companyName: {
    fontWeight: '400',
    fontSize: '0.825rem',
    lineHeight: '0.825rem',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  siteName: {
    fontWeight: '600',
    fontSize: '1.5rem',
    lineHeight: '2.5rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
    },
  },
  menuContainer: { flexBasis: '100px', padding: '20px 40px 0 0', textAlign: 'right' },
  menuButton: {
    color: '#0f487e',
  },
  menuIcon: {
    color: '#0f487e',
  },
  menuMasthead: {
    borderBottom: '1px solid #e0e0e0',
  },
  menuSiteName: {
    fontWeight: '600',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
  },
  menuTitleContainer: {
    flex: 1,
    padding: '2.5rem 1.5rem 1.5rem 1.5rem',
    color: '#0f487e',
    fontFamily: 'Roboto Slab',
  },
  list: {
    width: 325,
  },
  fullList: {
    width: 'auto',
  },
}));

const Header = () => {
  const classes = useStyles();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setMenuOpen(open);
  };

  const navigate = useNavigate();
  const navigateTo = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <header className={classes.masthead}>
      <div className={classes.logoContainer}>
        <a href="https://www.msla.org" target="_blank" rel="noopener noreferrer">
          <MSLALogo className={classes.mslaLogo} height="70" width="60" />
        </a>
      </div>
      <div className={classes.titleContainer}>
        <div className={classes.companyName}>{APPLICATION_OWNER_NAME}</div>
        <div className={classes.siteName}>{APPLICATION_NAME}</div>
      </div>
      <div className={`${classes.menuContainer} print-menu-container`}>
        <IconButton
          edge="end"
          className={classes.menuButton}
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer(true)}
        >
          <MenuIcon fontSize="large" />
        </IconButton>
        <Drawer anchor="right" open={menuOpen} onClose={toggleDrawer(false)}>
          <div
            className={classes.list}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
          >
            <div className={`${classes.masthead} ${classes.menuMasthead}`}>
              <div className={classes.logoContainer}>
                <MSLALogo className={classes.mslaLogo} height="70" width="60" />
              </div>
              <div className={classes.menuTitleContainer}>
                <div className={classes.menuSiteName}>{APPLICATION_NAME}</div>
              </div>
            </div>

            <List>
              <ListItem button onClick={() => navigateTo(ROUTE_CONSTANTS.HOME)}>
                <ListItemIcon>
                  <IsrHomeIcon className={classes.menuIcon} />
                </ListItemIcon>
                <ListItemText primary="ISR Home" />
              </ListItem>
              <ListItem button onClick={() => navigateTo(ROUTE_CONSTANTS.REPORT_PREMIUM_TREND)}>
                <ListItemIcon>
                  <PremiumTrendIcon className={classes.menuIcon} />
                </ListItemIcon>
                <ListItemText primary="Premium Trend" />
              </ListItem>
              <ListItem
                button
                onClick={() => navigateTo(ROUTE_CONSTANTS.REPORT_TRANSACTION_TYPE_COMPARISON)}
              >
                <ListItemIcon>
                  <TransactionTypeComparisonIcon className={classes.menuIcon} />
                </ListItemIcon>
                <ListItemText primary="Transaction Type Comparison" />
              </ListItem>
              <ListItem button onClick={() => navigateTo(ROUTE_CONSTANTS.INSURER)}>
                <ListItemIcon>
                  <InsurerDataSheetIcon className={classes.menuIcon} />
                </ListItemIcon>
                <ListItemText primary="Insurer Data Sheet" />
              </ListItem>
              <ListItem button onClick={() => navigateTo(ROUTE_CONSTANTS.COUNTY)}>
                <ListItemIcon>
                  <CountyDataSheetIcon className={classes.menuIcon} />
                </ListItemIcon>
                <ListItemText primary="County Data Sheet" />
              </ListItem>
              <ListItem button onClick={() => navigateTo(ROUTE_CONSTANTS.COVERAGECODE)}>
                <ListItemIcon>
                  <CoverageCodeSheetIcon className={classes.menuIcon} />
                </ListItemIcon>
                <ListItemText primary="Coverage Code Data Sheet" />
              </ListItem>
            </List>
          </div>
        </Drawer>
      </div>
    </header>
  );
};

export default Header;
